<template>
  <b-container>
    <b-row>
      <b-col cols="6">
        <span class="group-table-label">Selected Groups</span>
      </b-col>
      <b-col cols="6">
        <span class="group-table-label">Available Groups</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group v-slot="{ ariaDescribedby }">
          <div class="mt-6 table">
            <b-table sticky-header :fields="columnsToShow" :items="selectedGroupsFiltered" show-empty>
              <template #empty="scope">
                This user currently has no groups assigned.
              </template>
              <!-- A custom formatted data column cell -->
              <template #cell(id)="data" v-show="visibleIds">
                {{ data.value }}
              </template>
              <template #cell(name)="data">
                {{ data.value }}
              </template>
              <template #cell(selected)="{ item, field: { key } }">
                <b-form-checkbox
                    v-model="item[key]"
                    value="true"
                    unchecked-value="false"
                    :disabled=true
                />
              </template>
              <template #thead-top="data">
                <b-tr>
                  <b-th v-for="row in data.fields" :key="row.key">
                    {{ row.key === 'selected' ? 'Search' : '' }}
                    <b-input v-if="row.key === 'name' || row.key === 'id'" v-model="selectedGroupsFilters[row.key]"
                             :placeholder="row.label"/>
                  </b-th>

                </b-tr>
              </template>

              <!-- A custom formatted header cell for field 'name' -->
              <template #head(name)="data">
                <span class="text-info">{{ data.label }}</span>
              </template>

              <!-- A custom formatted footer cell for field 'name' -->
              <template #foot(name)="data">
                <span class="text-danger">{{ data.value }}</span>
              </template>

              <!-- Default fall-back custom formatted footer cell -->
              <template #foot()="data">
                <i>{{ data.name }}</i>
              </template>
            </b-table>
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group v-slot="{ ariaDescribedby }">
          <div class="mt-6 table">
            <b-table sticky-header :fields="columnsToShow" :items="filtered" foot-clone>
              <!-- A custom formatted data column cell -->
              <template #cell(id)="data">
                {{ data.value }}
              </template>
              <template #cell(name)="data">
                {{ data.value }}
              </template>
              <template #cell(selected)="{ item, field: { key } }">
                <span style="text-align: center">
                  <b-form-checkbox
                      v-model="item[key]"
                      value="true"
                      unchecked-value="false"
                      @change="updateSelectedGroups(item)"
                  /></span>
              </template>
              <!-- A custom formatted header cell for field 'name' -->
              <template #thead-top="data">
                <b-tr>
                  <b-th v-for="row in data.fields" :key="row.key">
                    {{ row.key === 'selected' ? 'Search' : '' }}
                    <b-input v-if="row.key === 'name' || row.key === 'id'" v-model="filters[row.key]"
                             :placeholder="row.label"/>
                  </b-th>

                </b-tr>
              </template>
              <!-- A custom formatted footer cell for field 'name' -->
              <template #foot(name)="data">
                <span class="text-danger">{{ data.value }}</span>
              </template>

              <!-- Default fall-back custom formatted footer cell -->
              <template #foot()="data">
                <i>{{ data.name }}</i>
              </template>
            </b-table>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
export default {
  name: "ChildGroupSelector",
  props: {
    availableGroups: Array,
    childGroups: {
      type: Array,
      default: []
    },
    value: {
      type: Array,
      default: []
    },
    showIds: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      groups: [],
      selectedGroups: this.value.map(val => {
        return {selected: true, id: val}
      }),
      groupCols: [
        {key: 'selected', label: 'Selected'},
        {key: 'id', label: 'ID'},
        {key: 'name', label: 'Name'},
      ],
      groupsList: this.availableGroups,
      groupRoleList: [],
      filters: {
        selected: '',
        id: '',
        name: ''
      },
      selectedGroupsFilters: {
        selected: '',
        id: '',
        name: ''
      },
      visibleIds: this.showIds
    }
  },
  watch: {
    availableGroups: function (newVal, oldVal) {
      this.groupsList = newVal;
    },
    childGroups: function (newVal, oldVal) {
      this.childGroups = newVal;
    },
    value: function (newVal, oldVal) {
      this.selectedGroups = this.value/*.map(val =>{ return {
        selected: true,
        id: val,
        name: this.groupsList.filter(val=> val.id === val).map(item=> item.name).first().name}})*/
    }
  },
  computed: {
    filtered() {
      if (!this.groupsList) {
        return []
      }
      const filtered = this.groupsList.filter(item => {
        let theFilters = Object.keys(this.filters);
        return theFilters.every(key => {
          let filterValue = this.filters[key];
          let itemValue = item[key];
          return String(itemValue).includes(filterValue);
        })
      })
      return filtered.length > 0 ? filtered : []
    },
    selectedGroupsFiltered() {
      const filtered = this.selectedGroups.filter(item => {
        let theFilters = Object.keys(this.selectedGroupsFilters);
        return theFilters.every(key => {
          let filterValue = this.selectedGroupsFilters[key];
          let itemValue = item[key];
          return String(itemValue).includes(filterValue);
        })
      })
      return filtered.length > 0 ? filtered : []
    },
    columnsToShow() {
      return this.groupCols.map(col => {
        if (col.key === 'id') {
          console.log("Should show column");
          col.visible = this.visibleIds;
        } else {
          col.visible = true;
        }
        return col;
      })
          .filter(col => col.visible === true);
    }
  },
  methods: {
    updateSelectedGroups(rowItem) {
      let isSelected = !(rowItem['selected'] === 'true' || rowItem['selected'] === true);
      let itemId = rowItem["id"];
      let groupsToAdd = this.groupsList.filter(val => val.id === itemId);
      console.log(`Row Id ${itemId}`);
      if (isSelected) {
        this.selectedGroups.push(...groupsToAdd);
      } else {
        this.selectedGroups = this.selectedGroups.filter(group => {
          return group.id !== itemId;
        })
      }
      this.$emit('input', this.selectedGroups)
    },
    updateIsGroupAdmin(rowItem) {
      let itemId = rowItem["id"];
      let groupToUpdate = rowItem;
      let isGroupAdmin = !(rowItem.groupAdminRole === 'true' || rowItem.groupAdminRole === true)
      if (isGroupAdmin) {
        rowItem.viewer = false;
      }
      this.selectedGroups.filter(group => {
        return group.id === itemId;
      })
          .forEach(group => {
            let groupAdminRole = !(groupToUpdate.groupAdminRole === 'true' || groupToUpdate.groupAdminRole === true);
            let index1 = this.selectedGroups.findIndex((element) => {
              if (element.id === groupToUpdate.id) {
                return true;
              }
            })
            group.groupAdminRole = groupAdminRole;
            if (groupAdminRole) {
              group.viewer = false;
            }
            this.$set(this.selectedGroups, index1, group);
          })
    },
    updateIsViewer(rowItem) {
      let itemId = rowItem["id"];
      let groupToUpdate = rowItem;
      let isViewer = !(rowItem.viewer === 'true' || rowItem.viewer === true)
      if (isViewer) {
        rowItem.groupAdminRole = false;
      }
      this.selectedGroups.filter(group => {
        return group.id === itemId;
      })
          .forEach(group => {
            let viewer = !(groupToUpdate.viewer === 'true' || groupToUpdate.viewer === true);
            let index1 = this.selectedGroups.findIndex((element) => {
              if (element.id === groupToUpdate.id) {
                return true;
              }
            })
            group.viewer = viewer;
            if (viewer) {
              group.groupAdminRole = false;
            }
            this.$set(this.selectedGroups, index1, group);
          })
    }
  }
}
</script>

<style scoped>

.group-table-label {
  font-weight: bold;
  font-size: x-large;
  font-family: "Courier New", serif;
  color: #1c7430;
}

</style>
